import { client, clientFunc } from './client';
const fetchUrlFromIndexHtml = document.getElementsByTagName('base')[0]?.getAttribute('linkedinurl');
let LinkedInURL = fetchUrlFromIndexHtml;

export async function fetchLinkedInFeed() {
    let result = await client("LinkedInWrapper/Read", "", "get", LinkedInURL);
    return result;
}

export async function fetchTuesdayFeed() {
    let result = await client("LinkedInWrapper/Tuesdays", "", "get", LinkedInURL);
    return result;
}

export async function submitContactForm(formData) {
    console.log('submitted contact form');
    const response = await clientFunc(formData, "post");
    return response;
}

